<template>
  <div>
    <el-row style="margin-top: 20px">
      <div class="m-auto text-right pb-3">
        <el-button @click="open()" type="primary" size="medium">
          <i class="el-icon-plus mr-2"></i>Add Main Category</el-button
        >
      </div>
      <el-alert
        title="Category names cannot edit once created. So please check before saving."
        type="warning"
        center
        show-icon>
      </el-alert>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="Main Category" width="180">
          <template slot-scope="scope">
            <!-- <i class="el-icon-time"></i> -->
            <span style="margin-left: 10px">{{ scope.row.mainCategory }}</span>
            <el-button
              type="danger"
              plain
              size="mini"
              icon="el-icon-delete"
              circle
              @click="openDelete(scope.row.mainCategory)"
            ></el-button>
          </template>
        </el-table-column>
        <el-table-column label="Sub Categries">
          <template slot-scope="scope">
            <div class="name-wrapper">
              <el-tag
                style="margin: 5px; font-size: 15px"
                type="info"
                :key="name"
                v-for="name in scope.row.subCategories"
                closable
                :disable-transitions="false"
                @close="openDelete2(name, scope.$index, scope.row)"
              >
                {{ name }}
              </el-tag>
              <el-input
                class="input-new-tag"
                v-if="scope.row.inputVisible"
                v-model="scope.row.newCategory"
                :ref="scope.$index"
                size="mini"
                placeholder="Hit enter to save"
                @keyup.enter.native="
                  handleInputConfirm(scope.$index, scope.row)
                "
                @blur="handleInputConfirm(scope.$index, scope.row)"
              >
              </el-input>
              <el-button
                v-else
                plain
                class="button-new-tag"
                size="small"
                type="success"
                @click="showInput(`new-tag-${scope.$index}`, scope.row)"
                >+ Add New</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>

<script>
import db from "../../config/FirebaseInit";
import firebase from "firebase/app";
export default {
  name: "managecategories",
  data() {
    return {
      inputVisible: false,
      inputValue: "",
      shops: [],
      categories: "",
      tableData: [],
    };
  },
  created() {
    this.$store.state.secondaryDatabase
      .collection("shops")
      .where("owner", "==", firebase.auth().currentUser.uid)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            categories: doc.data().categories,
            shopcat: doc.data().cat,
            shoptype: doc.data().shoptype,
            curProducts: doc.data().curProducts,
            maxProducts: doc.data().maxProducts,
            loc: doc.data().location,
            shopname: doc.data().name,
            catValues: doc.data().catValues,
            cansearch: doc.data().search,
          };
          this.shops.push(data);
          this.categories = this.shops[0].categories;
          Object.keys(this.categories)
            .sort()
            .forEach((key, index) => {
              const subcategories = [];
              Object.keys(this.categories[key])
                .sort()
                .forEach((subcat, index) => subcategories.push(subcat));
              this.tableData.push({
                mainCategory: key,
                subCategories: subcategories,
                newCategory: "",
                inputVisible: false,
              });
            });
          // console.log("this.categories is", this.categories, this.tableData);
        });
      })
      .catch((error) => alert(error));
  },
  methods: {
    openDelete(category) {
      this.$confirm(
        "This will permanently delete the category. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.deleteMainCat(category);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
    openDelete2(tag, index, row) {
      this.$confirm(
        "This will permanently delete the category. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.handleClose(tag, index, row);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
    // tag table tags
    handleClose(tag, index, row) {
      if (
        this.categories[row.mainCategory][tag] &&
        this.categories[row.mainCategory][tag] !== 0
      ) {
        // console.log(this.categories[row.mainCategory][tag]);
        this.$notify({
          title: "Error",
          message:
            "Delete all products in this category first to delete the category",
          type: "error",
          duration: 0,
        });
      } else {
        row.subCategories.splice(row.subCategories.indexOf(tag), 1);
        delete this.categories[row.mainCategory][tag];
        // console.log("this.categories", this.categories);
        this.$store.state.secondaryDatabase
          .collection("shops")
          .doc(this.shops[0].id)
          .update({
            categories: this.categories,
          })
          .then((doc) => {})
          .catch((error) => alert(error));
      }
    },

    showInput(index, row) {
      // console.log(index);
      row.inputVisible = true;
      // this.$nextTick(_ => {
      //   this.$refs[index].$refs.input.focus();
      // });
    },

    handleInputConfirm(index, row) {
      let inputValue = this.inputValue;
      if (row.newCategory) {
        // console.log(row.newCategory);
        row.subCategories.push(row.newCategory);
        this.categories[row.mainCategory][row.newCategory] = 0;
        this.$store.state.secondaryDatabase
          .collection("shops")
          .doc(this.shops[0].id)
          .update({
            categories: this.categories,
          })
          .then((doc) => {})
          .catch((error) => alert(error));
        // console.log("this.categories", this.categories);
      }
      row.inputVisible = false;
      // console.log(row.subCategories);
      row.newCategory = "";
    },
    deleteMainCat(category) {
      // console.log(this.shops[0].catValues[category]);
      if (
        this.shops[0].catValues[category] &&
        this.shops[0].catValues[category] !== 0
      ) {
        // console.log(this.shops[0].catValues[category]);
        this.$notify({
          title: "Error",
          message:
            "Delete all products in this category first to delete the category",
          type: "error",
          duration: 0,
        });
      } else {
        this.tableData = this.tableData.filter(
          (data) => data.mainCategory !== category
        );
        delete this.categories[category];
        this.$store.state.secondaryDatabase
          .collection("shops")
          .doc(this.shops[0].id)
          .update({
            categories: this.categories,
          })
          .then((doc) => {})
          .catch((error) => alert(error));
      }
    },
    open() {
      this.$prompt("Enter main category", "Main Category", {
        confirmButtonText: "Create",
        cancelButtonText: "Cancel",
        inputPattern: /^[a-zA-Z ]*$/,
        inputErrorMessage: "Invalid Input",
      })
        .then(({ value }) => {
          if (value === "" || value === undefined || value === null) {
            return this.$message({
              type: "error",
              message: "Input invalid",
            });
          }
          this.categories[value] = {};
          this.$store.state.categories[value] = {};
          this.tableData.push({
            mainCategory: value,
            subCategories: [],
            newCategory: "",
            inputVisible: false,
          });
          // console.log(this.categories);
          this.$store.state.secondaryDatabase
            .collection("shops")
            .doc(this.shops[0].id)
            .update({
              categories: this.categories,
            })
            .then((doc) => {})
            .catch((error) => alert(error));
          this.$message({
            type: "success",
            message: "Main category created",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Input canceled",
          });
        });
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/admin/ManageCategories.vue